//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "",
  data: function data() {
    var _this = this;

    // 表单检查，内容不可以超过1500字节
    var checkContent = function checkContent(rule, value, callback) {
      if (value.length > 1500) {
        callback(new Error(_this.$t('lang.smartsms.tips2')));
      } else {
        callback();
      }
    };

    return {
      used: "",
      total: "",
      list: [],
      editMsgDialog: false,
      editForm: {
        index: "",
        phone: "",
        content: "",
        meta_index: ""
      },
      pageSize: 10,
      currentPage: 1,
      editFormRules: {
        phone: [{
          required: true,
          message: this.$t('lang.smartsms.tips1'),
          trigger: 'blur'
        }],
        content: [{
          required: true,
          message: "不可以为空",
          trigger: 'blur'
        }, {
          validator: checkContent,
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    // 状态过滤器
    stateFilter: function stateFilter() {
      return function (state) {
        switch (state) {
          case '4':
            return this.$t('lang.smartsms.FailedToSend');

          case '3':
            return this.$t('lang.smartsms.SentSuccessfully');

          case '2':
            return this.$t('lang.smartsms.sending');

          case '5':
            return this.$t('lang.smartsms.draft');

          default:
            return "未知状态";
        }
      };
    },
    showList: function showList() {
      var start = (this.currentPage - 1) * this.pageSize;
      var end = this.currentPage * this.pageSize;
      return this.list.slice(start, end);
    }
  },
  methods: {
    openEditDialog: function openEditDialog(e) {
      this.editForm.phone = e.phone;
      this.editForm.content = e.content;
      this.editForm.index = e.index;
      this.editForm.meta_index = e.meta_index;
      this.editMsgDialog = true;
    },
    saveAsDraft: function saveAsDraft() {
      this.$emit('saveAsDraft', {
        index: this.editForm.index,
        phone: this.editForm.phone,
        content: this.editForm.content,
        state: '5',
        addIndex: this.list.length,
        meta_index: this.editForm.index
      });
    },
    deleteOutboxMsg: function deleteOutboxMsg(index, iindex) {
      var _this2 = this;

      console.log(index, iindex); // 确认框

      this.$confirm(this.$t('lang.smartsms.tips2'), this.$t('lang.smartsms.tips'), {
        confirmButtonText: this.$t('lang.smartsms.sure'),
        cancelButtonText: this.$t('lang.smartsms.cancel'),
        type: 'warning'
      }).then(function () {
        // 删除
        _this2.$emit('deleteOutboxMsg', {
          index: index,
          iindex: iindex
        });
      }).catch(function () {});
    },
    addOutMessage: function addOutMessage() {
      this.editForm = {
        index: "",
        phone: "",
        content: ""
      };
      this.editMsgDialog = true;
    },
    sendSms: function sendSms() {
      this.$emit('saveAsDraft', {
        index: this.editForm.index,
        phone: this.editForm.phone,
        content: this.editForm.content,
        state: '2',
        addIndex: this.list.length,
        meta_index: this.editForm.index
      });
    },
    sendSelectSms: function sendSelectSms(index, iindex) {
      this.$emit("sendSelectSms", {
        index: index,
        iindex: iindex
      });
    },
    refesh: function refesh() {
      this.$emit('refesh');
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
    }
  }
};